import styles from './table-filters.module.scss';
// import { CheckboxLabel } from '../checkbox/checkbox';
import { SwitchLabel } from '../switch/switch';

export interface iTableSwitch {
  label: string,
  onChange: (checked: boolean) => void,
  checked: boolean,
  disabled?: boolean
}
/* eslint-disable-next-line */
export interface TableFiltersProps {
  switches: iTableSwitch[]
}

export function TableFilters(props: TableFiltersProps) {
  return (<>
    {props.switches.map((c, index) => {
      const onChange = (event: any, checked: boolean) => c.onChange(checked)
      return <div style={{ display: "inline-flex" }} key={index}>
        <SwitchLabel
          label={c.label}
          checked={c.checked}
          onChange={onChange}
          disabled={c.disabled}
        />
      </div>
    })}
  </>);
}

export default TableFilters;